import { atom } from "recoil";

/**
 * This atom keeps track of the title to show for the document.
 */
export const DocumentTitleState = atom({
  key: "DocumentTitleState",
  default: "",
});
